import React, { useEffect } from 'react';
import { Table, message, Input, Button } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import BasePagination from '../../../components/pagination';
import TrainerColumns from './trainer_column';

import { restApi } from '../../../apis';
//----------------------------------------------------------------------------------------------------
const TrainerTable = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { refresh } = props;
  const [messageApi, contextHolder] = message.useMessage();
  const isBack = (location.state && location.state.isBack) || false;
  const [startNum, setStartNum] = React.useState(
    isBack ? location.state.startNum : 1
  );
  const [current, setCurrent] = React.useState(
    isBack ? location.state.current : -1
  );
  const [total, setTotal] = React.useState(isBack ? location.state.current : 0);
  const [sorts, setSorts] = React.useState(
    isBack
      ? location.state.sorts
      : {
          // selected: 'account_name',
          // account_name: 'asc', //desc
          // searchTxt: '',
          orderBy: 'center_name', //desc
          sort: 'asc', //desc
          searchTxt: '',
          // selected: 'center_name', //'center_name',
          // center_name: 'desc', //desc
          // created_at: 'desc', //desc
          // searchTxt: '',
          refresh: new Date(),
        }
  );
  const [searchTxt, setSearchTxt] = React.useState('');
  const [dataSource, setDataSource] = React.useState([]);

  // const loading = props.loading;
  const setLoading = props.setLoading;
  //----------------------------------------------------------------------------------------------------
  useEffect(() => {
    // 1페이지 정보 가져오기
    if (!isBack) {
      setCurrent(1);
    }
  }, []);

  useEffect(() => {
    if(current == -1) {
      return;
    }

    //페이지가 변경되면 서버로 부터 데이터 가져오기
    // 로딩
    setLoading(true);
    //페이지가 변경되면 서버로 부터 데이터 가져오기
    (async (args) => {
      const params = {
        // pageNum: current,
        // orderBy: sorts.selected,
        // sort: sorts[sorts.selected],
        // account_name: searchTxt,
        pageNum: current,
        orderBy: sorts.orderBy,
        sort: sorts.sort,
        searchTxt: searchTxt,
      };

      const response = await restApi.get(`/admin/trainer`, {
        params,
      });

      const payload = response && response.data && response.data.payload;
      if (payload) {
        setTotal(payload.totalCount || 1);
        setDataSource(payload.trainerList || []);
      }
      setLoading(false);
    })();
  }, [current, refresh, sorts]);

  //----------------------------------------------------------------------------------------------------
  const OnCellClick = (args) => {
    const uuid = args.id;
    navigate(`/trainers/details/${uuid}`, {
      replace: true,
      state: {
        isBack: false,
        current,
        total,
        sorts,
      },
    });
  };

  //----------------------------------------------------------------------------------------------------
  return (
    <div>
      {contextHolder}
      <div
        style={{
          display: 'flex',
          width: '100%',
          height: '3rem',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-end',
          background: '#FFF',
          padding: 0,

          // font
          fontFamily: 'Public Sans',
          fontStyle: 'normal',
        }}
      >
        <div>{`통합검색`}</div>
        <Input
          style={{
            marginLeft: '1rem',
            marginRight: '1rem',
            width: '20%',
            height: '3rem',
          }}
          // value={value}
          onChange={(e) => {
            setSearchTxt(e.target.value);
          }}
          onKeyDown={(e) => {
            if(e.key == 'Enter') {
              setSorts((prev) => {
                return {
                  ...prev,
                  searchTxt: searchTxt,
                };
              });
            }
          }}
        />
        <Button
          type="primary"
          // htmlType={'submit'}
          // loading={loading}
          style={{
            display: 'flex',
            width: '6rem',
            height: '2.8rem',
            justifyContent: 'center',
            alignItem: 'center',
            background: '#7367F0',
            // font
            fontWeight: 600,
            fontSize: '1.5rem',
            lineHeight: '2.2rem',
          }}
          onClick={(e) => {
            setSorts((prev) => {
              return {
                ...prev,
                searchTxt: searchTxt,
              };
            });
          }}
        >
          {`검색`}
        </Button>
      </div>
      <Table
        columns={TrainerColumns({
          ...props,
          messageApi,
          sorts,
          setSorts,
          OnCellClick,
        })}
        dataSource={dataSource}
        pagination={false}
        sizePopup= {0}
        showSorterTooltip = { false }
        sortDirections = {['ascend' | 'descend']}
        // sizePopup= {0}
        // showSorterTooltip = { false }
        // sortDirections = {['ascend' | 'descend']}
        // components={components}
        // loading={loading}
      />
      <BasePagination
        startNum={startNum}
        setStartNum={setStartNum}
        current={current}
        setCurrent={setCurrent}
        total={total}
        pageSize={10}
        {...props}
      />
    </div>
  );
};

export default TrainerTable;
